import { html } from "lit-html";
import { HauntedFunc } from "Shared/haunted/HooksHelpers";
import { AdminPostModel, DEFAULT_ADMIN_POST_MODEL } from "./DynamicSettings";
import { useState } from "Shared/haunted/CustomHooks";
import { useAjax } from "Services/useAjax";

export const observedAttributes: (keyof Attributes)[] = ["login-error-message"];

export const name = "admin-login";

export interface Attributes {
	"login-error-message": string;
}

export interface Props {
	loginErrorMessage: string;
}

export const Component: HauntedFunc<Props> = (host) => {
	const props: Props = {
		loginErrorMessage: host.loginErrorMessage || "",
	};

	const { ajaxRequest } = useAjax();

	const [secret, setSecret] = useState<string>("");

	const handleSubmit = async () => {
		const postBody: AdminPostModel = { ...DEFAULT_ADMIN_POST_MODEL, Secret: secret, ActionType: "login" };
		await ajaxRequest({ url: "/samuraijack", body: postBody });
		window.location.reload();
	};

	const handleSecretInput = (e: InputEvent) => setSecret((e.target as HTMLInputElement).value);

	return html`
		<div class="flex gap-4">
			<input
				class="flex h-10 appearance-none items-center rounded-lg border border-solid border-black px-4"
				type="password"
				placeholder="Password"
				@input=${handleSecretInput}
			/>
			<button class="bg-n-blue hover:bg-n-red hover:text-white" value="Login" @click=${handleSubmit}>Login</button>
			<label class="text-[#db0000]">${props.loginErrorMessage}</label>
		</div>
	`;
};
